import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ETagType, ITag } from '../../cos/tags.model';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IListApiModel } from '../models/api.model';

@Injectable({
  providedIn: 'root',
})
export class TagsService {

  constructor(
    private readonly http: HttpClient,
  ) {
  }

  getTags(): Observable<IListApiModel<ITag>> {
    return this.http.get<IListApiModel<ITag>>(environment.apiUrl + '/v1/tags/list', {
      params: new HttpParams({
        fromObject: {
          type: 'Account',
          paginated: 'false',
        }
      })
    });
  }

  createTag(name: string, type: ETagType = ETagType.ACCOUNT): Observable<any> {
    return this.http.post<any>(environment.apiUrl + '/v1/tags', {
      name,
      type,
    });
  }

  updateTag(id: number, name: string): Observable<any> {
    return this.http.put<any>(environment.apiUrl + '/v1/tags/' + id, { name });
  }

  deleteTag(id: number): Observable<any> {
    return this.http.delete<any>(environment.apiUrl + '/v1/tags/' + id);
  }
}
